import React, { useState } from 'react';
import { Menu, MenuItem, IconButton, Typography, Divider, Tooltip } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import styles from './OptionsMenu.module.css';
import getOptionTextColor from "../../../../../utils/getOptionsColor";
import { IAddEscalationFuncParams, IMenuOption } from "../../../../../Models/applicationModels";
import { ReactComponent as ViewDetails } from '../../../../../Assets/viewDetails.svg'

export interface OptionsMenuProps {
    record: Record<string, any>;
    options: IMenuOption;
    onViewDetails:(opportunityId: string) => void;
}

// Handled View Details Externally.
type OptionTypes = keyof OptionsMenuProps['options'] | null | "View Details";

const OptionsMenu: React.FC<OptionsMenuProps> = (props) => {

    const {
        record,
        options,
        onViewDetails
    } = props;

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [currentSection, setCurrentSection] = useState<OptionTypes>(null);

    const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => setAnchorEl(event.currentTarget);

    const handleMenuClose = () => {
        setAnchorEl(null);
        setTimeout(() => setCurrentSection(null), 100);
    };

    const handleSectionChange = (option: OptionTypes) => {
        if(option === null){
            return;
        }

        if (option === "View Details") {
            onViewDetails(record.opportunityUid);
            handleMenuClose();
        } else {
            setCurrentSection(option);
        }
    };

    const handleOptionSelect =async (id: string,name:string = "") => {
        if (currentSection) {
            switch (currentSection) {
            }
        }
        handleMenuClose();
    };

    return (
        <>
            <Tooltip title="View Details" arrow>
                <IconButton aria-label="options" onClick={() => handleSectionChange("View Details")} size="small">
                    <ViewDetails width={18} height={18} className={styles.moreInfoIcon} />
                </IconButton>
            </Tooltip>
            {/*<Menu*/}
            {/*    anchorEl={anchorEl}*/}
            {/*    open={Boolean(anchorEl)}*/}
            {/*    onClose={handleMenuClose}*/}
            {/*    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}*/}
            {/*    transformOrigin={{ vertical: 'top', horizontal: 'left' }}*/}
            {/*    classes={{ paper: styles.menuCtn, list: styles.menuListItems }}*/}
            {/*>*/}

            {/*    {currentSection === null ? (*/}
            {/*        <>*/}
            {/*            {Object.keys(options)*/}
            {/*                .filter((option) => options[option as keyof IMenuOption].length > 0)*/}
            {/*                .map((option, index) => (*/}
            {/*                <MenuItem*/}
            {/*                    key={index}*/}
            {/*                    className={`${styles.menuItem} ${styles.menuItemOuter}`}*/}
            {/*                    onClick={() => handleSectionChange(option as OptionTypes)}*/}
            {/*                >*/}
            {/*                    {option in options ? "Add " : ""}*/}
            {/*                    {option.charAt(0).toUpperCase() + option.slice(1)}*/}
            {/*                </MenuItem>*/}
            {/*            ))}*/}
            {/*            /!* Adding "View Details" Option *!/*/}
            {/*            <MenuItem*/}
            {/*                key="view-details"*/}
            {/*                className={`${styles.menuItem} ${styles.menuItemOuter}`}*/}
            {/*                onClick={() => handleSectionChange("View Details")}*/}
            {/*            >*/}
            {/*                View Details*/}
            {/*            </MenuItem>*/}
            {/*        </>*/}
            {/*    ) : (*/}
            {/*        <>*/}
            {/*            <Typography variant="subtitle2" className={styles.header}>*/}
            {/*                {currentSection.charAt(0).toUpperCase() + currentSection.slice(1)} Options*/}
            {/*            </Typography>*/}
            {/*            <Divider className={styles.divider} />*/}
            {/*            {currentSection in options ? (*/}
            {/*                options[currentSection as keyof IMenuOption].map((option, index) => (*/}
            {/*                    <MenuItem*/}
            {/*                        key={index}*/}
            {/*                        className={styles.menuItem}*/}
            {/*                        onClick={() => handleOptionSelect(option.id, option.name)}*/}
            {/*                        style={{ color: getOptionTextColor(currentSection || "", option.id) }}*/}
            {/*                    >*/}
            {/*                        {option.name}*/}
            {/*                    </MenuItem>*/}
            {/*                ))*/}
            {/*            ) : null}*/}
            {/*        </>*/}
            {/*    )}*/}
            {/*</Menu>*/}
        </>
    );
};

export default OptionsMenu;